/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { API_PATH } from "../../../environments/config";
import { dateFormats } from "../../../environments/config";

@Injectable({
  providedIn: "root",
})
export class LocationService {
  latitude;
  longitude;
  address;
  distance;
  isLocationEnabled;
  fromdate = 0;
  todate = 0;
  country = "India";
  dateFormats = dateFormats;
  format = dateFormats[this.country];
  public promolinkSearchText: string = "";
  public roomplanerSearchText: string = "";
  constructor(private http: HttpClient) {}

  getPosition(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          this.latitude = resp.coords.latitude;
          this.longitude = resp.coords.longitude;
          resolve({
            longitude: resp.coords.longitude,
            latitude: resp.coords.latitude,
          });
          this.isLocationEnabled = true;
        },
        (err) => {
          reject(err);
          if (err.message === "User denied Geolocation") {
            this.isLocationEnabled = false;
          }
        }
      );
    });
  }

  getCountryStateCityData(type, id?, stateId?) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("type", type);
    httpParams = id ? httpParams.set("id", id) : httpParams;
    httpParams = stateId ? httpParams.set("stateId", stateId) : httpParams;
    return this.http.get(API_PATH.apis.getCscData, { params: httpParams });
  }

  formatDates() {
    let currentBusinessUnit = JSON.parse(
      sessionStorage.getItem("currentBusinessUnit")
    );
    this.country = currentBusinessUnit.address?.country;
    if (
      this.country == "United States" ||
      this.country == "India" ||
      this.country == "UK" ||
      this.country == "Ireland"
    ) {
      this.format = this.dateFormats[this.country];
    } else {
      this.format = this.dateFormats.India;
    }
  }

  getdistance(lat1, lon1, lat2, lon2) {
    if (lat1 == lat2 && lon1 == lon2) {
      return 0;
    } else {
      var radlat1 = (Math.PI * lat1) / 180;
      var radlat2 = (Math.PI * lat2) / 180;
      var theta = lon1 - lon2;
      var radtheta = (Math.PI * theta) / 180;
      var dist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = (dist * 180) / Math.PI;
      dist = dist * 60 * 1.1515;
      dist = dist * 1.609344;
      return dist;
    }
  }
  gettodate() {
    return this.todate;
  }
  settodate(data) {
    this.todate = data;
  }
  getfromdate() {
    return this.fromdate;
  }
  setfromdate(data) {
    this.fromdate = data;
  }

  resetDates() {
    this.fromdate = 0;
    this.todate = 0;
    this.promolinkSearchText = "";
    this.roomplanerSearchText = "";
  }
}
